import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { FlexCenter } from '../../global/commonStyle';
import { AVATAR_BORDER } from '../../global/constants';

interface Props {
  size?: number;
  email?: string;
  borderVariant?: (typeof AVATAR_BORDER)[keyof typeof AVATAR_BORDER];
  randColor?: string;
  borderRadius?: string;
}
const UserLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  img {
    z-index: var(--z-index-base);
    background-color: var(--background-muted);
  }
`;

const TextWrapper = styled.div<Props>`
  border-radius: ${({ borderRadius }) => borderRadius || 'var(--border-radius-full)'};
  ${FlexCenter}
  color: var(--text-white);
  background-color: ${(props: Props) => props.randColor};
  z-index: var(--z-index-base);
  span {
    ${Typography.body_xs};
  }
  ${(props: Props) =>
    props.size &&
    css`
      width: ${props.size}px;
      height: ${props.size}px;
    `}
  ${(props: Props) =>
    props.borderVariant === AVATAR_BORDER.THICK &&
    css`
      border: 5px solid var(--background-secondary);
      border-radius: var(--border-radius-full);
    `}
      ${(props: Props) =>
    props.borderVariant === AVATAR_BORDER.THIN &&
    css`
      border: 1px solid var(--background-secondary);
      border-radius: var(--border-radius-full);
    `}
      ${(props: Props) =>
    props.borderVariant === AVATAR_BORDER.MEDIUM &&
    css`
      border: 2px solid var(--background-secondary);
    `}

    ${(props: Props) =>
    props.borderVariant === AVATAR_BORDER.NONE &&
    css`
      border: none;
    `}
`;

export { UserLogoWrapper, TextWrapper };
